// src/pages/SearchProducts.jsx
import React from 'react';

export default function SearchProducts() {
  return <div>Search page coming soon…</div>;
}
